import {DatabaseCode, toDatabaseCode, toDatabaseCodeSafely} from "../database-code";

export type ServiceEventCloseoutStatus = DatabaseCode;

const pending: ServiceEventCloseoutStatus = {
  code: "PENDING",
  displayValue: {
    id: "common.entity.serviceeventcloseoutstatus.pending",
    defaultMessage: "Pending",
  },
};

const inProgress: ServiceEventCloseoutStatus = {
  code: "IN_PROGRESS",
  displayValue: {
    id: "common.entity.serviceeventcloseoutstatus.inprogress",
    defaultMessage: "In Progress",
  },
};

const completed: ServiceEventCloseoutStatus = {
  code: "COMPLETED",
  displayValue: {
    id: "common.entity.serviceeventcloseoutstatus.completed",
    defaultMessage: "Completed",
  },
};

const failed: ServiceEventCloseoutStatus = {
  code: "FAILED",
  displayValue: {
    id: "common.entity.serviceeventcloseoutstatus.failed",
    defaultMessage: "Failed",
  },
};

export const serviceEventCloseoutStatus = {
  pending,
  inProgress,
  completed,
  failed,
};

export const serviceEventCloseoutStatuses: ServiceEventCloseoutStatus[] = Object.values(serviceEventCloseoutStatus);

export const toServiceEventCloseoutStatus = (code: string): ServiceEventCloseoutStatus =>
  toDatabaseCode(code, serviceEventCloseoutStatuses);

export const toServiceEventCloseoutStatusSafely = (
  code: string | undefined,
  defaultValue: ServiceEventCloseoutStatus | undefined = undefined
): ServiceEventCloseoutStatus | undefined => toDatabaseCodeSafely(code, serviceEventCloseoutStatuses, defaultValue);
